import { useEffect, useState } from 'react';
import { T } from '../../components/text/TextEdit';
import { useTranslation } from 'react-i18next';
import { RefreshCw } from 'lucide-react';
import { api } from '../../lib/api';
import { Button } from '../ui/button';

// Compact "Regenerate with:" control — the keyless-aware model picker (from C) + a Regenerate button.
// Picks an EXPLICIT model_id override; keyless models are flagged but still selectable so the user can
// force one (the server then runs the platform default — resolution A — and the served badge shows it).
export function RegenerateWithModel({ onRegenerate, busy = false, testId = 'regenerate-with-model' }) {
  const { t } = useTranslation();
  const [models, setModels] = useState([]);
  const [sel, setSel] = useState('');

  useEffect(() => {
    api.modelKeyAvailability().then((r) => setModels(r?.models || [])).catch(() => {});
  }, []);

  if (!models.length) return null;
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid={testId}>
      <span className="text-xs font-medium text-muted-foreground"><T k="common.regenerateWith" /></span>
      <select
        className="text-xs border border-border rounded-md px-2 py-1 bg-card text-foreground"
        value={sel}
        onChange={(e) => setSel(e.target.value)}
        disabled={busy}
        data-testid={`${testId}-select`}
      >
        <option value=""><T k="walletCore.modelDefault" /></option>
        {models.map((m) => (
          <option key={m.model_id} value={m.model_id}>
            {(m.display_label || m.model_id) + (m.has_key === false ? ` · ${t('settings.modelNoKey')}` : '')}
          </option>
        ))}
      </select>
      <Button
        size="sm"
        variant="outline"
        disabled={busy}
        onClick={() => onRegenerate(sel || undefined)}
        data-testid={`${testId}-button`}
      >
        <RefreshCw className="h-3.5 w-3.5 me-1.5" /> {t('common.regenerate')}
      </Button>
    </div>
  );
}
